const initLivTabSection = (section) => {
  const nav = section.querySelector('.liv-tab-section__tabs');
  const prev = section.querySelector('.liv-tab-section__custom-icon--prev');
  const next = section.querySelector('.liv-tab-section__custom-icon[name="next"]');

  section.addEventListener('click', (e) => {
    const tab = e.target.closest('.liv-tab-section__tab');
    if (tab) {
      section.querySelectorAll('.liv-tab-section__tab').forEach(t => t.classList.toggle('is-active', t === tab));
      section.querySelectorAll('.liv-tab-section__content').forEach(p => p.classList.toggle('is-active', p.id === tab.dataset.tabTarget));
      window.dispatchEvent(new Event('resize'));
    }
    const arrow = e.target.closest('.liv-tab-section__custom-icon');
    if (arrow && nav) nav.scrollBy({ left: nav.offsetWidth * 0.7 * (arrow === next ? 1 : -1), behavior: 'smooth' });
  });

  section.querySelectorAll('.drag-slider').forEach(slider => {
    let isDown = false, x, left;
    slider.addEventListener('mousedown', e => { isDown = true; x = e.pageX - slider.offsetLeft; left = slider.scrollLeft; slider.classList.add('is-dragging'); });
    window.addEventListener('mouseup', () => { isDown = false; slider.classList.remove('is-dragging'); });
    slider.addEventListener('mousemove', e => { if (isDown) slider.scrollLeft = left - (e.pageX - slider.offsetLeft - x) * 2; });
  });

  const update = () => {
    if (!nav || !prev || !next) return;
    const scrollable = nav.scrollWidth > nav.offsetWidth + 2;
    const atStart = nav.scrollLeft <= 5;
    const atEnd = nav.scrollLeft >= nav.scrollWidth - nav.offsetWidth - 5;

    // Toggle disabled class instead of hiding
    prev.classList.toggle('is-disabled', !scrollable || atStart);
    next.classList.toggle('is-disabled', !scrollable || atEnd);
    
    // Ensure they are always visible (overriding any inline styles if needed)
    prev.style.opacity = '1';
    prev.style.visibility = 'visible';
    prev.style.pointerEvents = (!scrollable || atStart) ? 'none' : 'auto';
    
    next.style.opacity = '1';
    next.style.visibility = 'visible';
    next.style.pointerEvents = (!scrollable || atEnd) ? 'none' : 'auto';
  };
  
  nav?.addEventListener('scroll', update);
  window.addEventListener('resize', update);
  update();
};

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.liv-tab-section').forEach(initLivTabSection);
});

// Support for Shopify Theme Editor (CMS)
// This re-initializes the JS whenever a section setting is changed
document.addEventListener('shopify:section:load', (event) => {
  const sectionContainer = event.target.querySelector('.liv-tab-section');
  if (sectionContainer) initLivTabSection(sectionContainer);
});
